import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    deleteInvestmentProjectRequest: ['response'],
    deleteInvestmentProjectSuccess: ['loading', 'response'],
    deleteInvestmentProjectFailure: ['error'],
})

export const deleteInvestmentProjectTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
})

/* ------------- Reducers ------------- */

const deleteInvestmentProjectRequest = state => state.merge({ success: null })

const deleteInvestmentProjectSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const deleteInvestmentProjectFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.DELETE_INVESTMENT_PROJECT_REQUEST]: deleteInvestmentProjectRequest,
    [Types.DELETE_INVESTMENT_PROJECT_SUCCESS]: deleteInvestmentProjectSuccess,
    [Types.DELETE_INVESTMENT_PROJECT_FAILURE]: deleteInvestmentProjectFailure,
})
